import React from 'react';
import Container from '@mui/material/Container';
import { Section } from 'components/styledComponents';
import Resume from './Resume';
import WidgetsHeader from './WidgetsHeader';

import {
  Education,
  ExecutiveSummary,
  CompetenceProfile,
  ITSkills,
  Languages,
  OtherActivities,
  PersonalDetails,
  WorkExperience
} from './sections';

import { useLocation } from 'react-router-dom';

function ResumePage({ loading }) {
  const location = useLocation();
  const url = location.pathname;

  return (
    <React.Fragment>
      <WidgetsHeader />
      <PersonalDetails loading={loading} editPath={url} />

      <Section>
        <Container>
          <Resume editPath={url} loading={loading} />
          <ExecutiveSummary editPath={url} />
          <CompetenceProfile editPath={url} />
          <WorkExperience className="bottom-separator" />
          <Education />
          <Languages className="bottom-separator" />
          <ITSkills className="bottom-separator" />
          <OtherActivities />
        </Container>
      </Section>
    </React.Fragment>
  );
}

export default ResumePage;
